import { Component, Input } from '@angular/core';

type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

@Component({
  selector: 'shared-info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss'],
  host: { class: 'd-inline-flex' },
  standalone: false,
})
export class InfoIconComponent {
  private _infoIconKey = 'information-circle';

  get infoIconKey(): string {
    return this._infoIconKey;
  }

  @Input() set infoIconKey(value: string) {
    if (!value) {
      return;
    }
    this._infoIconKey = value;
  }

  @Input() size: IconSize = 'sm';
  @Input() color: string;

  // if color is not provided, then use the default color
  get colorClass(): string {
    return this.color ? this.color : 'color-primary';
  }
}
